import { render, staticRenderFns } from "./DispersionViz.vue?vue&type=template&id=0369032d&scoped=true"
import script from "./DispersionViz.vue?vue&type=script&lang=js"
export * from "./DispersionViz.vue?vue&type=script&lang=js"
import style0 from "./DispersionViz.vue?vue&type=style&index=0&id=0369032d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0369032d",
  null
  
)

export default component.exports